import React, { useState } from "react";
import { Autocomplete, Box, Button, Dialog } from "@mui/material";
import { DialogContent, Stack, TextField, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import Repo from "../../Repository/Repo";
import { Toast } from "../components/Toast";
import Loader from "../components/Loader";

function EditIncentives({ open, onClose, item, onSuccess }) {
  const { employees } = useSelector((state) => state.employee);
  const [loading, setLoading] = useState(false);
  const [state, setState] = useState({
    employeeId: item.employeeId || "",
    employeeName: item.employeeName || "",
    incentivePer: item.incentivePer || "",
    saleTarget: item.saleTarget || "",
  });
  const handleEmployee = (e, val) => {
    setState((prev) => ({
      ...prev,
      employeeId: val.userId,
      employeeName: val.userName,
    }));
  };
  const toggle = () => {
    if (!loading) {
      onClose();
    }
  };
  const isOptionEqualToValue = (option, value) => {
    return option === value || value === "";
  };
  const handleInput = (e) => {
    const { name, value } = e.target;
    setState((prev) => ({ ...prev, [name]: value }));
  };
  const handleSubmit = async () => {
    const { employee, incentivePer, saleTarget } = state;
    if (employee == "" || incentivePer == "" || saleTarget == "") {
      Toast("info", "Fill all fields");
      return;
    }
    setLoading(true);

    let { data } = await Repo.incentive({
      request: {
        method: "updateIncentive",
        data: {
          ...state,
          _id: item._id,
          _rev: item._rev,
          company_code: localStorage.getItem("companyCode"),
        },
      },
    });
    setLoading(false);
    toggle();
    if (data.response.status.statusCode == 200) {
      Toast("success", "Update Successfully");
      onSuccess();
    } else {
      Toast("error", "Not Updated");
      onSuccess();
    }
  };
  return (
    <Dialog open={open} onClose={toggle} fullWidth>
      <DialogContent>
        <Stack spacing={2}>
          <Typography
            variant="h6"
            sx={{ color: "#43af51", textAlign: "center" }}
          >
            Update Incentives
          </Typography>
          <Autocomplete
            options={employees}
            getOptionLabel={(option) => option.userName || ""}
            isOptionEqualToValue={isOptionEqualToValue}
            defaultValue={{ userName: item.employeeName }}
            onChange={(e, val) => {
              handleEmployee(e, val);
            }}
            renderInput={(params) => (
              <TextField {...params} size="small" label="Select Employee" />
            )}
          />

          <TextField
            fullWidth
            variant="outlined"
            size="small"
            label="Sale Target"
            name="saleTarget"
            value={state.saleTarget}
            onChange={handleInput}
          />
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            label="Incentive %"
            name="incentivePer"
            value={state.incentivePer}
            onChange={handleInput}
          />
          {!loading && (
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Button size="small" variant="contained" onClick={handleSubmit}>
                Update
              </Button>
            </Box>
          )}

          {loading && <Loader loading={loading} />}
        </Stack>
      </DialogContent>
    </Dialog>
  );
}

export default EditIncentives;
